<template>
    <div
        class="fixed top-1/3 right-0 z-10 origin-bottom-right -rotate-90"
        data-spec-class="vertical-buttons"
    >
        <div class="flex gap-3">
            <TheFeedbackButton />
            <TheSupportButton />
        </div>
    </div>
</template>

<script setup lang="ts">
import TheFeedbackButton from './TheFeedbackButton.vue';
import TheSupportButton from './TheSupportButton.vue';
</script>
